'use strict';
/* jshint -W106 */

angular.module('shiftTraderApp')
  .service('EventStreamsService', ['EventStreamNames', function (EventStreamNames) {
    var streams = {};


    var Stream = function(name) {
      var s = {
        name: name,
        subject: new Rx.Subject()
      };

      s.getChannel = function() {
        return s.subject;
      };

      s.push = function(type, data) {
        // console.log('pushing event onto ' + s.name, type, data);
        s.subject.onNext({type: type, data: data});
      };

      s.filterByType = function(type) {
        if (!Array.isArray(type)) {
          type = [type]
        }

        return s.subject.filter(function(obj) {
          return _.contains(type, obj.type);
        });
      };

      return s;
    };

    function getStream(name) {
      if (!streams[name]) {
        // console.log('creating new stream', name);
        streams[name] = new Stream(name);
      } else {
        // console.log('return stream', name);
      }

      return streams[name];
    }

    return {
      getStream: getStream,
      names: EventStreamNames
    };

  }]);
